import React from "react";
import { Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import { IconButton } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import clsx from "clsx";
import OptimizationRunTime from "../common/OptimizationRunTime";

type ThemeWithCustom = Theme & {
  AppBGColor?: string;
  headerTextFontSize?: number;
  HeaderSelectedText?: string;
  ModalBGColor?: string;
};

const styles = (theme: Theme) => {
  const t = theme as ThemeWithCustom;
  return {
  headerStyle: {
    borderBottom: `1px solid ${t.AppBGColor}`,
    fontSize: t.headerTextFontSize,
    color: t.HeaderSelectedText,
    padding: "6px 10px 6px 10px",
    display: "flex" as const,
    alignItems: "center",
    justifyContent: "space-between" as const,
  },
  headerTitleWithRunTime: {
    display: "flex" as const,
    alignItems: "center",
    gap: "8px",
  },
  expandMain: {
    backgroundColor: t.ModalBGColor,
    color: t.HeaderSelectedText,
    transform: "rotate(0deg)",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
    padding: 5,
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  };
};

export type RouteSolutionHeaderProps = WithStyles<typeof styles> & {
  count: number;
  expanded: boolean;
  onToggle: () => void;
  optimizationRunTime?: string | null;
};

const RouteSolutionHeader = ({
  classes,
  count,
  expanded,
  onToggle,
  optimizationRunTime,
}: RouteSolutionHeaderProps): React.ReactElement => (
  <div className={classes.headerStyle}>
    <div className={classes.headerTitleWithRunTime}>
      <span>Review Optimized Solution ({count})</span>
      {optimizationRunTime && (
        <OptimizationRunTime runTime={optimizationRunTime} />
      )}
    </div>
    <IconButton
        aria-expanded={expanded}
        aria-label="show more"
        className={clsx(classes.expandMain, {
          [classes.expandOpen]: expanded,
        })}
        onClick={onToggle}
      >
        <ExpandMoreIcon />
      </IconButton>
  </div>
);

export default withStyles(styles)(RouteSolutionHeader);
